"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var input_1 = require("../input");
var PercentageInput = /** @class */ (function (_super) {
    tslib_1.__extends(PercentageInput, _super);
    function PercentageInput(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChange = function (e) {
            e.stopPropagation();
            e.target.value = e.target.value === "" ? "" : Number(e.target.value) / 100;
            _this.props.onChange(e);
        };
        return _this;
    }
    PercentageInput.prototype.render = function () {
        var _a = this.props, value = _a.value, precision = _a.precision, onValueChange = _a.onValueChange, others = tslib_1.__rest(_a, ["value", "precision", "onValueChange"]);
        return (React.createElement(input_1.FormInput, tslib_1.__assign({ step: "any" }, others, { type: "number", value: value === "" ? "" : Math.round(value * 100), onChange: this.onChange })));
    };
    PercentageInput.defaultProps = {};
    return PercentageInput;
}(React.Component));
exports.default = PercentageInput;
